import { Component, OnInit, ViewChild } from "@angular/core";
import { ListColumn } from "src/app/models/list-columns.model";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ProgramarService } from "./historial.service";
import { NgxSpinnerService } from "ngx-spinner";
import * as FileSaver from "file-saver";
import { MantenimientosDTO } from "src/app/models/dto/mantenimientos.dto";
import { Filter } from "src/app/shared/classes/filter";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { AlertasSwalService } from "src/app/services/alerts.service";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: "app-historial",
  templateUrl: "./historial.component.html",
  styles: [],
})
export class HistorialMantenimientoComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo",
      property: "TipoDesc",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Programado",
      property: "FechaProgramadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Inicio",
      property: "Inicio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "F. Inicio",
      property: "FechaIniciadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Termino",
      property: "Termino",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "F. Termino",
      property: "FechaTerminadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public columnsCancelados: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo",
      property: "TipoDesc",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Programado",
      property: "FechaProgramadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Cancelo",
      property: "Cancelo",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Cancelado",
      property: "FechaCanceladoStr",
      visible: true,
      isModelProperty: true,
    },
  ];

  public actions: any[] = [
    {
      desc: "Obtener reporte",
      action: "pdf",
      visible: (row) => true,
    },
  ];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild("CardTableComponentCanceladas", { static: true })
  public tableCompCancel: CardTableComponent;

  filtro: string = "";
  realdata: MantenimientosDTO[] = [];
  realdataCancel: MantenimientosDTO[] = [];

  constructor(
    public service: ProgramarService,
    public spinner: NgxSpinnerService,
    public alerts: AlertasSwalService,
  ) {}

  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<MantenimientosDTO>(
      this.conditions,
      this.columns,
      true,
    );
    this.filterCancel = new Filter<MantenimientosDTO>(
      this.conditionsCancel,
      this.columnsCancelados,
      true,
    );
  }

  loadRecords() {
    this.service.getHistorial().subscribe(
      (resultData) => {
        const data = resultData.map((m) => {
          const dateIniciado = dayjs.utc(m.FechaIniciado);
          const dateTerminado = dayjs.utc(m.FechaTerminado);

          // Convert to GMT -8 (Pacific Time)
          const gmt8DateIniciado = dateIniciado.tz("America/Los_Angeles");
          const fechaTransform = m.FechaIniciado ? gmt8DateIniciado : null;
          const gmt8DateTerminado = dateTerminado.tz("America/Los_Angeles");
          const fechaTerminadoTransform = m.FechaTerminado
            ? gmt8DateTerminado
            : null;

          return {
            ...m,
            TipoDesc: m.Tipo == 1 ? "Correctivo" : "Preventivo",
            FechaProgramadoStr: dayjs(m.FechaProgramado).format("DD/MM/YYYY"),
            FechaIniciadoStr: fechaTransform
              ? fechaTransform.format("DD/MM/YYYY hh:mm a")
              : "",

            FechaTerminadoStr: fechaTerminadoTransform
              ? fechaTerminadoTransform.format("DD/MM/YYYY hh:mm a")
              : "",
          };
        });
        this.realdata = data;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );

    this.service.getCancelados().subscribe(
      (resultData) => {

        const data = resultData.map((m) => {
          const dateCancelado = dayjs.utc(m.FechaCancelado);

          // Convert to GMT -8 (Pacific Time)
          const gmt8DateCancelado = dateCancelado.tz("America/Los_Angeles");
          const fechaTransform = m.FechaCancelado ? gmt8DateCancelado : null;

          return {
            ...m,
            TipoDesc: m.Tipo == 1 ? "Correctivo" : "Preventivo",
            FechaProgramadoStr: dayjs(m.FechaProgramado).format("DD/MM/YYYY"),
            FechaCanceladoStr: fechaTransform
              ? fechaTransform.format("DD/MM/YYYY hh:mm a")
              : "",
          };
        });

        this.realdataCancel = data;
        this.filterCancel.setDataTable(
          this.realdataCancel,
          this.tableCompCancel,
        );
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  //#region Filter

  public filter: Filter<MantenimientosDTO>;
  public conditions: Condition<MantenimientosDTO> = {
    TipoDesc: (o, f) => o.TipoDesc.toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Unidad: (o, f) =>
      (o.Unidad ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Razon: (o, f) => o.Razon.toLocaleLowerCase().indexOf(f) > -1,
    Inicio: (o, f) => o.Inicio.toLocaleLowerCase().indexOf(f) > -1,
    Termino: (o, f) => o.Termino.toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  public filterCancel: Filter<MantenimientosDTO>;
  public conditionsCancel: Condition<MantenimientosDTO> = {
    TipoDesc: (o, f) => o.TipoDesc.toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Unidad: (o, f) =>
      (o.Unidad ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Razon: (o, f) => o.Razon.toLocaleLowerCase().indexOf(f) > -1,
    Cancelo: (o, f) => o.Cancelo.toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdataCancel(e: FilterEvent) {
    this.filterCancel.filterdata(e, this.realdataCancel, this.tableCompCancel);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "pdf") {
      this.downLoad(e.row.IdMantenimiento, e.row.Folio);
    }
  }
  downLoad(e, folio) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "mantenimiento_" + folio + ".pdf",
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      },
    );
  }

  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
}
